// import abstract from '../assets/abstract.jpg';
// import face from '../assets/face.jpg';
// import sculpture from '../assets/sculpture.jpg';
import homeImage from '../assets/homeImage.png';

export default function Carousel() {

    return (
        <div>
            <div id="carouselExample" className="carousel slide">
                <div className="carousel-inner">
                    <div className="carousel-item active" style={{height: "80vh"}}>
                        <img src={homeImage} className="d-block w-100" alt="..."/>
                    </div>
                    {/* <div className="carousel-item" style={{height: "80vh"}}>
                        <img src={abstract} className="d-block w-100" alt="..."/>
                    </div>
                    <div className="carousel-item" style={{height: "80vh"}}>
                        <img src={face} className="d-block w-100" alt="..."/>
                    </div>
                    <div className="carousel-item" style={{height: "80vh"}}>
                        <img src={sculpture} className="d-block w-100" alt="..."/>
                    </div> */}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
}


